import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GraphConfigurationTag, GraphConfigurationYAxis, LineGraphType, TagInfos, YAxisPosition } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-color-tag-graph',
    templateUrl: './modal-color-tag-graph.component.html',
    styleUrls: ['./modal-color-tag-graph.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalColorTagGraphComponent implements OnInit {
 // FORM
 get f() {
  return this.detailForm.controls;
}

tag: TagInfos;
yAxis: Array<GraphConfigurationYAxis> = [];
yAxisPositions = Object.values(YAxisPosition);
tags : Array<GraphConfigurationTag>;
newAxisMode: boolean = false;
indexYaxis : number;
LineTypes = Object.values(LineGraphType);
axisUpdate: boolean = false
detailForm: any;

constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ModalColorTagGraphComponent>) {
  if(this.data.tags){
    this.tags = this.data.tags;
    this.axisUpdate = true;
    this.newAxisMode = true;
  }else{
    this.tag = this.data.tag;
  }
  
  this.yAxis = this.data.yAxis;
  if(this.yAxis.length === 0) {
    this.newAxisMode = true;
  }
  this.detailForm = this.fb.group({
    color: [''],
    width: [1],
    type: [LineGraphType.SOLID],
    tag: [""],
    yAxisSelect: [''],
    yAxisName: [this.tag ? this.tag.unit : ''],
    yAxisColor: [''],
    min: [''],
    max: [''],
    position: [YAxisPosition.LEFT],
  });
  
 }

ngOnInit(): void {
  this.checkValidatorsForm();
}


updateForm(selectedType: any){

  this.detailForm = this.fb.group({
    color: [selectedType.color],
    width: [selectedType.width],
    type: [selectedType.type],
    tag: [selectedType],
    yAxisSelect: [this.yAxis[selectedType.yAxis - 1]],
    yAxisName: [this.yAxis[selectedType.yAxis - 1].name],
    yAxisColor: [this.yAxis[selectedType.yAxis - 1].color],
    min: [this.yAxis[selectedType.yAxis - 1].min],
    max: [this.yAxis[selectedType.yAxis - 1].max],
    position: [this.yAxis[selectedType.yAxis - 1].position],
  });
  
  this.tag  = {
    displayName : selectedType.name,
    uid : selectedType.uid,
  };
  this.indexYaxis = this.yAxis[selectedType.yAxis - 1].index;
}
onToggleAxisMode() {
  this.newAxisMode = !this.newAxisMode;
  this.checkValidatorsForm();
}

checkValidatorsForm() {
  if(this.newAxisMode) {
    this.detailForm.get('yAxisName').setValidators([Validators.required]);
    this.detailForm.controls["yAxisName"].updateValueAndValidity();

    this.detailForm.get('yAxisSelect').clearValidators();
    this.detailForm.controls["yAxisSelect"].updateValueAndValidity();
  } else {
    this.detailForm.get('yAxisSelect').setValidators([Validators.required]);
    this.detailForm.controls["yAxisSelect"].updateValueAndValidity();

    this.detailForm.get('yAxisName').clearValidators();
    this.detailForm.controls["yAxisName"].updateValueAndValidity();
  }
}

onSubmit() {
  if(this.detailForm.valid) {
    if(this.newAxisMode) {
      const yAxis: GraphConfigurationYAxis= {
        name: this.f.yAxisName.value ? this.f.yAxisName.value : null,
        color: this.f.yAxisColor.value ? this.f.yAxisColor.value : '#000000',
        min: this.f.min.value || this.f.min.value === 0 ? this.f.min.value : null,
        max: this.f.max.value || this.f.max.value === 0 ? this.f.max.value : null,
        position: this.f.position.value,
        index: this.indexYaxis? this.indexYaxis : this.yAxis.length > 0 ? this.yAxis[this.yAxis.length - 1].index + 1 : 1
      }
  
      const configuredTag: GraphConfigurationTag = {
        uid: this.tag.uid,
        name: this.tag.displayName,
        color: this.f.color.value ? this.f.color.value : '#000000',
        width: this.f.width.value,
        type: this.f.type.value,
        yAxis: yAxis.index
      }
  
      const result = {
        configuredTag: configuredTag,
        yAxis: yAxis,
      }
      this.dialogRef.close(result);
      
    } else {
      const configuredTag: GraphConfigurationTag = {
        uid: this.tag.uid,
        name: this.tag.displayName,
        color: this.f.color.value ? this.f.color.value : '#000000',
        width: this.f.width.value,
        type: this.f.type.value,
        yAxis: this.f.yAxisSelect.value
      }

      const result = {
        configuredTag: configuredTag,
      }

      this.dialogRef.close(result);
    }
  }
}
onTagSelected(event: any) {
  const tagSelected = this.tags[event.target.selectedIndex];
  this.updateForm(tagSelected)
}
}
